<app-common-report-form
  [formTitle]="'Zajbejelentő űrlap'"
  [formCategory]="'NOISE_REPORT'"
></app-common-report-form>
